// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"89":"component---src-templates-page-js","125":"component---src-pages-404-js","346":"component---src-pages-home-alt-js"}[chunkId] || chunkId) + "-" + {"89":"60db70ecfe634a92d9dc","125":"afa1eaac39ad453d5a1a","346":"7f200b69c800a2247050","360":"f9bf2fd20fbb2639fcec","913":"852979c4f8a6c7853b9d"}[chunkId] + ".js";
};